import { render, staticRenderFns } from "./userInputData.vue?vue&type=template&id=13fc96a1&"
import script from "./userInputData.vue?vue&type=script&lang=js&"
export * from "./userInputData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports